import React from 'react';
import {
  StyledSlider,
  SlideWrapper,
  StyledUL,
  NextSlide,
  PrevSlide,
} from './slider.css';

class RapidDetoxSlides extends React.Component {
  render() {
    const settings = {
      accessibility: true,
      adaptiveHeight: true,
      arrows: true,
      centerMode: false,
      draggable: false,
      infinite: true,
      nextArrow: <NextSlide />,
      prevArrow: <PrevSlide />,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 500,
    };
    return (
      <StyledSlider {...settings}>
        <SlideWrapper>
          <h1>HyperMed Advanced Rapid Opiate Detox Protocol </h1>
          <h3>
            Stopping addiction in just 8 hours with no withdrawal or relapse.
          </h3>
          <hr />
          <iframe
            width="100%"
            height="600px"
            src="https://www.youtube.com/embed/6lHTGYoy5vQ?rel=0&amp;controls=0&amp;showinfo=0"
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen={false}
          />
        </SlideWrapper>
        <SlideWrapper>
          <h1>Rapid Opiate Detox Market</h1>
          <hr />
          <StyledUL>
            <li>40,000 Americans die every year from opiate drug overdose.</li>
            <li>
              Las Vegas Rapid Detox Clinic, owned by HyperMed, uses a
              patent-pending technique to stop opiate addiction in just 8 hours,
              without withdrawal or relapse.{' '}
            </li>
            <li>
              We have treated over 600 patients without complications since
              2007, with revenues averaging over 1 million dollars annually.
            </li>
          </StyledUL>
        </SlideWrapper>
        <SlideWrapper>
          <h1>Advanced Rapid Opiate Detox (A.R.O.D.) Protocol</h1>
          <hr />
          <StyledUL>
            <li>
              8 hours of treatment, longer and more thorough than any other
              protocol; patients wake up with no withdrawal.
            </li>
            <li>
              Utilizes an FDA-approved, long-acting opiate antagonist called
              Vivitrol, lasting 30 days to prevent relapse.
            </li>
            <li>
              Monitoring the brain waves and brain metabolism during the
              procedure to ensure patient safety.
            </li>
          </StyledUL>
        </SlideWrapper>
        <SlideWrapper>
          <h1>Business of Rapid Detox</h1>
          <hr />
          <StyledUL>
            <li>
              Currently, HyperMed operates 1 rapid detox clinic, doing an
              average of 90 cases a year charging $12,000 per procedure
              generating more than $1 million dollars in revenue annually.
            </li>
            <li>
              HyperMed is seeking an investment of $10 million dollars to expand
              operation of rapid detox from the current 1 clinic, to 10
              company-owned clinics which forecasts over 2000 cases and $20
              million annually within the first 36 months of funding.
            </li>
            <li>
              HyperMed seeks to create franchise and licensing structures within
              6 years of funding forecasting over 10,000 cases every year from
              licensees or franchisees, generating an annual revenue of
              approximately $100 million world-wide.
            </li>
          </StyledUL>
        </SlideWrapper>
      </StyledSlider>
    );
  }
}

export default RapidDetoxSlides;
